import { type ReactNode } from 'react';

import { CollapsibleSection } from 'cpool-components/general/CollapsibleSection';

type Props = {
    badge?: ReactNode;
    children: ReactNode;
    title: string;
};

export const OffersCollapsible: React.FC<Props> = ({ badge, children, title }) => (
    <CollapsibleSection
        bgClassNames="flex h-full min-h-0 w-full flex-col overflow-hidden rounded-md border-l-2 border-blue bg-white p-2.5"
        defaultOpen
        headerClassNames="h-[25px] shrink-0 pl-1.5"
        keepMounted
        panelClassNames="mt-2.5 min-h-0 flex-1"
        title={
            <span className="flex items-center gap-2.5">
                {title}
                {badge}
            </span>
        }
        titleClassNames="text-sm font-medium text-midnight"
    >
        <div className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto rounded-md">{children}</div>
    </CollapsibleSection>
);
